document.querySelectorAll('[data-fibrax-homepage]').forEach((root) => {
  if (root.dataset.fxReady) return;
  root.dataset.fxReady = 'true';

  const select = root.querySelector('[data-fx-finder-select]');
  const result = root.querySelector('[data-fx-finder-result]');
  const title = root.querySelector('[data-fx-finder-title]');
  const copy = root.querySelector('[data-fx-finder-copy]');
  const link = root.querySelector('[data-fx-finder-link]');
  if (!select || !result) return;

  const urls = {
    products: root.dataset.productsUrl || '/pages/productos?view=fibrax-productos',
    calculator: root.dataset.calculatorUrl || '/pages/calculadora?view=fibrax-calculadora',
    comparator: root.dataset.comparatorUrl || '/pages/comparador?view=fibrax-comparador',
    advisor: root.dataset.advisorUrl || '/pages/contacto'
  };

  const recommendations = {
    mortar: ['Duomix M20', 'Microfibra para controlar la fisuración plástica en morteros y aplanados.', urls.products, 'Ver microfibras'],
    sidewalk: ['Synmix EZ54', 'Macrofibra para banquetas y andadores; calcula volumen, dosificación y compra.', urls.calculator, 'Calcular cantidad'],
    garage: ['Synmix EZ54', 'Macrofibra para cocheras y patios de tránsito residencial.', urls.comparator, 'Comparar acero vs fibra'],
    commercial: ['Synmix EZ54', 'Macrofibra estructural con validación recomendada según cargas y espesor.', urls.calculator, 'Preparar estimación'],
    lightIndustrial: ['Synmix EZ54', 'Solución para pisos industriales de carga ligera, sujeta a validación técnica.', urls.advisor, 'Solicitar validación'],
    heavyIndustrial: ['Dramix 4D 80/60BGE', 'Fibra metálica para cargas mayores y operación industrial; requiere ingeniería.', urls.advisor, 'Solicitar ingeniería'],
    pavement: ['Synmix EZ54', 'Alternativa para pavimentos y exteriores, condicionada a tránsito, soporte y juntas.', urls.advisor, 'Revisar proyecto']
  };

  const update = () => {
    const item = recommendations[select.value];
    if (!item) {
      result.hidden = true;
      return;
    }
    title.textContent = item[0];
    copy.textContent = item[1];
    link.href = item[2];
    link.textContent = `${item[3]} →`;
    result.hidden = false;
  };
  select.addEventListener('change', update);
  update();

  root.querySelectorAll('[data-fx-add-product]').forEach((button) => {
    button.addEventListener('click', () => window.FibraxCore.addToCart({
      variantId: button.dataset.variantId,
      quantity: 1,
      root,
      button,
      properties: { Origen: 'Página de inicio FIBRAX' }
    }));
  });
});
